export default {
    request(req, token) {
        this.drivers.http.setHeaders.call(this, req, {
            Authorization: "Bearer " + token,
        });
    },
    response(res) {
        return (res.data.data || {}).token;
    },
};
